import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { CognitoService } from './cognito.service';
import { UtilService } from './util.service';
import { MessageService, MessageGoToSWAccountInfo, MessageLoginDev, MessageLoginOnClick, MessageCordovaCloseNotification } from './message.service';
import { LazyLoadingService } from './lazy-loading.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private cognitoService: CognitoService,
    private utilService: UtilService,
    private messageService: MessageService,
    private lazyLoadingService: LazyLoadingService
  ) {
    this.messageService.getMessage().subscribe(message => {
      if (message.name === MessageGoToSWAccountInfo) {
        this.SWAccountInfoBtnOnClick(message.data.email);
      }
      else if (message.name === MessageLoginOnClick) {
        this.loginBtnOnClick();
      }
    });
  }

  signupBtnOnClick() {
    this.utilService.gtag('config', { pageTitle: 'sign up', pagePath: '/sign_up.html' });
    if (AppService.isPW()) {
      this.cognitoService.signUp();
    } else if (AppService.isIOS()) {
      this.cognitoService.signUpIOS();
    } else if (AppService.isAndroid()) {
      this.messageService.sendMessage({ name: MessageCordovaCloseNotification });
      this.cognitoService.signUpAndroid();
    } else if (AppService.isSoftware()) {
      this.utilService.openExternalWindow('signUp', '');
    }
  }

  loginBtnOnClick() {
    this.utilService.gtag('config', { pageTitle: 'login', pagePath: '/login.html' });
    localStorage.setItem('NrLoginDate', new Date().toUTCString());
    if (AppService.isPW()) {
      if (window.location.href.includes('localhost')) {
        this.nonSSOLogin();
      } else {
        this.cognitoService.login();
      }
    } else if (AppService.isIOS()) {
      this.cognitoService.loginIOS();
    } else if (AppService.isAndroid()) {
      this.messageService.sendMessage({ name: MessageCordovaCloseNotification });
      this.cognitoService.loginAndroid();
    } else if (AppService.isSoftware()) {
      this.nonSSOLogin();
    }
  }

  nonSSOLogin() {
    this.lazyLoadingService.loadLoginModule()
    .then(() => {
      this.messageService.sendMessage({ name: MessageLoginDev });
    })
    .catch(err => {
      console.log('loadLoginDevModule err ', err);
    });
  }

  logoutBtnOnClick() {
    this.utilService.gtag('config', { pageTitle: 'logout', pagePath: '/logout.html' });
    return this.cognitoService.logout().then(() => {
      if(AppService.isAndroid() || AppService.isIOS()){
        window.location.replace("./index.html");
      } else{
        window.location.reload();
      }
    });
  }

  SWAccountInfoBtnOnClick(email: string) {
    this.utilService.openExternalWindow('login', email);
  }
}
